jQuery(document).ready(function () { 
  jQuery('.plus-icon').on('click',function(){
    jQuery(this).parent().toggleClass('open');
    //jQuery(this).parent().parent().find('.submenu').show();
    //jQuery('.minus-icon').show();
  });
  jQuery('.minus-icon').on('click',function(){
    jQuery(this).parent().parent().find('.submenu').hide();
    jQuery('.plus-icon').hide();
  });
 jQuery('.product-tab li').click(function(){
      jQuery('.product-tab li').removeClass('active');
      jQuery(this).addClass('active'); 
       var activeTab = jQuery(this).attr('id');
       jQuery( ".tab-product-wrap .tab-content" ).each(function( index ) {
               var content_id = $( this ).attr('id');
           //  $( ".tab-product-wrap .tab-content" ).hide();
               if(activeTab == content_id)
               {
                 jQuery( ".tab-product-wrap .tab-content" ).hide();
                 console.log(activeTab);
                 console.log(content_id);
                   jQuery( this ).show();
               }
          });
      });

       jQuery('.tab-products').owlCarousel({
          loop:true,
          margin:10,
          nav:true,
          dots: false,
          responsive:{
              0:{
                  items:2,
                  dots: true 
              },
              600:{
                  items:3,
                  dots: true 
              },
              1000:{
                  items:4
              }
          }
      }); 
      setTimeout(function(){
            jQuery('.related-product-section .product-grid').owlCarousel({
                    loop:true,
                    margin:10,
                    nav:true,
                    dots: false,
                    responsive:{
                        0:{
                            items:2,
                            dots: true 
                        },
                        600:{
                            items:3,
                            dots: true 
                        },
                        1000:{
                            items:6
                        }
                    }
                }); 
   },1000);   
      jQuery('.most-popular-slider').owlCarousel({
          loop:true,
          margin:10,
         // nav:true,
          dots: true,
          responsive:{
              0:{
                  items:1
              },
              600:{
                  items:3
              },
              1000:{
                  items:1
              }
          }
      }); 

jQuery('.search__button').on('click',function(){
  var a = jQuery('.search__input').val();
     if ($('.predictive-search-results-queries-list').length === 0) {
        jQuery('.search__input').addClass('error');
        jQuery('<span class="error-msg">Please enter keyword</span>').insertAfter('.search');
      } else {
        jQuery('.search__input').removeClass('error');
        jQuery('.error-msg').hide();
      }
});
   jQuery('#Subscribe').on('click', function(e) {
        jQuery('.error_msg').remove();
        jQuery('.newsletter-form__message--success').hide();
        var email = jQuery('.Email-footer').val();
        if (email === '') {
            e.preventDefault();  // Prevent form submission
            jQuery('.Email-footer').addClass('error');  // Add error class to input field
            jQuery('<span class="error_msg">This field is required</span>').insertAfter('.news-letter-wrap');  // Display error message
        } else {
            if (validateEmail(email)) {
               jQuery('.Email-footer').removeClass('error');  // Remove error class if email is valid
            } else {
                e.preventDefault();  // Prevent form submission
               jQuery('.Email-footer').addClass('error');  // Add error class to input field
                jQuery('<span class="error_msg">Please enter a valid email address.</span>').insertAfter('.news-letter-wrap');  // Display error message
            }
        }
    });
    // Email validation function
    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
     var $elements = jQuery(".shopify-section-group-footer-group");

        // Check if we have more than one before wrapping
        if ($elements.length > 0) {
            $elements.wrapAll('<div class="footer-wrap"></div>');
        }

     jQuery('#login-btn').click(function(e)
     {
      var login_flg,login_pwd  = 0;
      var email = jQuery("#CustomerEmail").val();
      var password = jQuery("#CustomerPassword").val(); 
      jQuery('.error-msg').remove(); 
  			if(email == "")
              {
                e.preventDefault();
                jQuery('#CustomerEmail').addClass('error');
                jQuery( "<p class='error-msg'>Please enter a email address</p>" ).insertAfter( "#CustomerEmail" );

                login_flg =1;
              }
              else if( !validateEmail(email))
              {
                  e.preventDefault();
                  jQuery('#CustomerEmail').addClass('error');
                  jQuery( "<p class='error-msg'>Please enter a valid email address</p>" ).insertAfter( "#CustomerEmail" );
              		login_flg =2;
                }
                else
                {
                  login_flg = 0;
                   jQuery('#CustomerEmail').removeClass('error');
                   
                }
            
              if(password == "")
              {
                e.preventDefault();
                jQuery('#CustomerPassword').addClass('error');
                jQuery( "<p class='error-msg'>Please enter a password</p>" ).insertAfter( "#CustomerPassword" );
                login_pwd =1;
              }
              else
              {
                jQuery('#CustomerPassword').removeClass('error');
                login_pwd = 0;
              }
    
    if(login_flg == 1 || login_pwd == 1)
    {
        jQuery( "<p class='error-msg all-field-err'>One or more fields have an error. Please check and try again.</p>" ).insertAfter( "#login-btn" );
        return false;
    }
   
          });   
//================== forgot password js =================
jQuery('.forgot-btn').click(function()
  {  
    var flag = 0;
    var email = jQuery("#RecoverEmail").val();  
   if(email == "")
              {
                jQuery('#RecoverEmail').addClass('error');
                
              }
              else
              {
                if( !validateEmail(email))
                 { 
                  jQuery('#RecoverEmail').addClass('error');
                  
                 }
                else
                {
                   jQuery('#RecoverEmail').removeClass('error');
                   
                }
              } 
  
  if(jQuery('#RecoverEmail').hasClass('error'))
              {     
                if(email!="")  
                {
                  jQuery('.error-msg').remove();
                   jQuery( "<p class='error-msg'>Please enter a valid email address</p>" ).insertAfter( "#RecoverEmail" );
                   return false;	
                }
                else{
                  
                  jQuery('.error-msg').remove();
                   jQuery( "<p class='error-msg'>Please enter an email address.</p>" ).insertAfter( "#RecoverEmail" );   
                   return false;
                }
                
         }
    });  
   //================ focus js ==============
   jQuery('input,textarea').on('focus', function() {
    jQuery(this).parent().addClass('has-focus');
  });

  jQuery('input,textarea').on('focusout', function() {
    if(jQuery(this).val() == '') {
      jQuery(this).parent().removeClass('has-focus');
    }
  }); 

   $('input, textarea').each(function() {
    if ($(this).val().trim() !== '') {
      $(this).parent().addClass('has-focus');
    }
  });   

  jQuery('.register-btn').click(function() {
    var reg_flg, reg_pwd = 0, reg_frstname = 0, reg_lastname = 0, reg_confirmpwd = 0;
    var fname = jQuery('#RegisterForm-FirstName').val();
    var lname = jQuery("#RegisterForm-LastName").val(); 
    var email = jQuery("#RegisterForm-email").val();
    var password = jQuery("#RegisterForm-password").val();
    var confirm_password = jQuery("#RegisterForm-confirm-password").val();

    jQuery('.error-msg').remove(); // remove old errors

    // First Name
    if(fname == '') {
        jQuery('#RegisterForm-FirstName').addClass('error');
        reg_frstname = 1;
        jQuery("<p class='error-msg'>Please enter a first name</p>").insertAfter("#RegisterForm-FirstName");
    } else {
        jQuery('#RegisterForm-FirstName').removeClass('error');
        reg_frstname = 0;
    }

    // Last Name
    if(lname == "") {
        jQuery('#RegisterForm-LastName').addClass('error');
        jQuery("<p class='error-msg'>Please enter a last name</p>").insertAfter("#RegisterForm-LastName");
        reg_lastname = 1;
    } else {
        jQuery('#RegisterForm-LastName').removeClass('error');
        reg_lastname = 0;
    }

    // Email
    if(email == "") {
        jQuery('#RegisterForm-email').addClass('error');
        jQuery("<p class='error-msg'>Please enter an email address</p>").insertAfter("#RegisterForm-email");
        reg_flg = 1;
    } else if(!validateEmail(email)) {
        jQuery('#RegisterForm-email').addClass('error');
        jQuery("<p class='error-msg'>Please enter a valid email address</p>").insertAfter("#RegisterForm-email");
        reg_flg = 2;
    } else {
        reg_flg = 0;
        jQuery('#RegisterForm-email').removeClass('error');
    }

    // Password Validation
    if(password == "") {
        jQuery('#RegisterForm-password').addClass('error');
        jQuery("<p class='error-msg'>Please enter a password</p>").insertAfter("#RegisterForm-password");
        reg_pwd = 1;
    } else if(password.length < 6) {
        jQuery('#RegisterForm-password').addClass('error');
        jQuery("<p class='error-msg'>Password must be at least 6 characters long</p>").insertAfter("#RegisterForm-password");
        reg_pwd = 1;
    } else if(!validatePassword(password)) {
        jQuery('#RegisterForm-password').addClass('error');
        jQuery("<p class='error-msg'>Password must contain at least one digit and one special character</p>").insertAfter("#RegisterForm-password");
        reg_pwd = 1;
    } else {
        jQuery('#RegisterForm-password').removeClass('error');
        reg_pwd = 0;
    }

    // Confirm Password Validation
    if(confirm_password == "") {
        jQuery('#RegisterForm-confirm-password').addClass('error');
        jQuery("<p class='error-msg'>Please confirm your password</p>").insertAfter("#RegisterForm-confirm-password");
        reg_confirmpwd = 1;
    } else if(confirm_password !== password) {
        jQuery('#RegisterForm-confirm-password').addClass('error');
        jQuery("<p class='error-msg'>Passwords do not match</p>").insertAfter("#RegisterForm-confirm-password");
        reg_confirmpwd = 1;
    } else {
        jQuery('#RegisterForm-confirm-password').removeClass('error');
        reg_confirmpwd = 0;
    }

    // Final Check
    if(reg_flg == 1 || reg_flg == 2 || reg_pwd == 1 || reg_frstname == 1 || reg_lastname == 1 || reg_confirmpwd == 1) {
        jQuery("<p class='error-msg all-field-err'>One or more fields have an error. Please check and try again.</p>").insertAfter(".register-btn");
        return false;
    } else if(reg_flg == 2) {
        jQuery("<p class='error-msg'>Please enter a valid email address</p>").insertAfter(".email-wrap");
        return false;
    } else {
        return true; // allow form submit
    }
});

function validatePassword(password) {
    // At least one digit and one special character (any non-letter/number)
    var regex = /^(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/;
    return regex.test(password);
}      

    jQuery(".search__input").on("focus click", function () {
       jQuery('.error-msg').remove(); // remove error class
    });   
    
    window.onscroll = function() {
        let btn = document.getElementById("scrollTopBtn");
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
          btn.style.display = "block";
        } else {
          btn.style.display = "none";
        }
    };

  // scroll to top on click
  document.getElementById("scrollTopBtn").onclick = function() {
     window.scrollTo({ top: 0, behavior: 'smooth' });
  };
jQuery('.contact-btn').click(function(e)
          {
               jQuery('.note--success').hide();
               jQuery('#not-valid-ins').hide();
               jQuery('#form-comment-after').hide();
               jQuery('.error-msg').hide();
               var NameError = 0;
               var emailError = 0;
               var messageErrors = 0;
               

             var Name = jQuery("#ContactForm-name").val();
             var email = jQuery("#ContactForm-email").val();
             var message = jQuery(".ContactFormMessage-contact-details").val();
                
           
               if(!Name) {
                    jQuery('#ContactForm-name').addClass('error');
                    jQuery('<span class="error-msg">Please enter full name</span>').insertAfter('#ContactForm-name');
                    NameError = 1;
                } else {
                    jQuery('#ContactForm-name').removeClass('error');
                }
               
                if(!email)
             	 {
                   jQuery('#ContactForm-email').addClass('error');
                   jQuery('<span class="error-msg">Please enter email address</span>').insertAfter('#ContactForm-email');
             	 }
             	 else
                {
                  //console.log("denmjb");
                  if( !validateEmail(email))
                   { 

                    jQuery('#ContactForm-email').addClass('error');
                    emailError = 1;
                    jQuery('<span class="error-msg">Please enter a valid email address</span>').insertAfter('#ContactForm-email');

                   }
                else {
                   
                    jQuery('#ContactForm-email').removeClass('error');
                     }
              }
              if(!message)
              {
                jQuery('.ContactFormMessage-contact-details').addClass('error');
                jQuery('<span class="error-msg">Please enter a message</span>').insertAfter('.ContactFormMessage-contact-details');
                messageErrors=1;
              }
              else
              {
                jQuery('.ContactFormMessage-contact-details').removeClass('error');
                
              }
            
          if( NameError || emailError || messageErrors ) {
            e.preventDefault();
            var errorHTML = '<span id ="form-comment-after">One or more fields have an error. Please check and try again</span>';
            jQuery(errorHTML).insertAfter('#ContactForm');  
                      return false;
              
			}
     else
     {
       return true;
     }
		});       
    jQuery('#recover-pass-form').on('click',function(){
       jQuery('body').addClass('forgot_password');
    });
    jQuery('.forgot-cancel').on('click',function(){
       jQuery('body').removeClass('forgot_password');
    });   
    jQuery('.new-address').on('click',function(e){
      jQuery('.error-msg').hide();
    var Name = jQuery('#AddressFirstNameNew').val();
    var lname = jQuery('#AddressLastNameNew').val();
    var address1 = jQuery('#AddressAddress1New').val();
    var city = jQuery('#AddressCityNew').val();
    var zipcode = jQuery('#AddressZipNew').val();
    var phone = jQuery('#AddressPhoneNew').val();
    var country = jQuery('#AddressCountryNew').val();     
             if(country == '---') {
              e.preventDefault();
                    jQuery('#AddressCountryNew').addClass('error');
                    jQuery('<span class="error-msg">Please select country</span>').insertAfter('#AddressCountryNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressCountryNew').removeClass('error');
                }
            if(!phone) {
              e.preventDefault();
                    jQuery('#AddressPhoneNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter phone number</span>').insertAfter('#AddressPhoneNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressPhoneNew').removeClass('error');
                }
            if(!zipcode) {
              e.preventDefault();
                    jQuery('#AddressZipNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter zipcode</span>').insertAfter('#AddressZipNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressZipNew').removeClass('error');
                }
            if(!city) {
              e.preventDefault();
                    jQuery('#AddressCityNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter city</span>').insertAfter('#AddressCityNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressCityNew').removeClass('error');
                }
            if(!Name) {
              e.preventDefault();
                    jQuery('#AddressFirstNameNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter first name</span>').insertAfter('#AddressFirstNameNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressFirstNameNew').removeClass('error');
                }
            if(!lname) {
              e.preventDefault();
                    jQuery('#AddressLastNameNew').addClass('error');
                    jQuery('<span class="error-msg">Please enter last name</span>').insertAfter('#AddressLastNameNew');
                    NameError = 1;
                } else {
                    jQuery('#AddressLastNameNew').removeClass('error');
                }
            if(!address1) {
              e.preventDefault();
                    jQuery('#AddressAddress1New').addClass('error');
                    jQuery('<span class="error-msg">Please enter address</span>').insertAfter('#AddressAddress1New');
                    NameError = 1;
                } else {
                    jQuery('#AddressAddress1New').removeClass('error');
                }

    });
   
      jQuery('.update-address').on('click',function(e){
        jQuery('.error-msg').hide();
      var Name = jQuery('.AddressFirstName').val();
      var lname = jQuery('.AddressLastName').val();
      var address1 = jQuery('.AddressAddress1').val();
      var city = jQuery('.AddressCity').val();
      var zipcode = jQuery('.AddressZip').val();
      var phone = jQuery('.AddressPhone').val();
      var country = jQuery('.AddressCountry').val();     
             if(country == '---') {
              e.preventDefault();
                    jQuery('.AddressCountry').addClass('error');
                    jQuery('<span class="error-msg">Please select country</span>').insertAfter('.AddressCountry');
                    NameError = 1;
                } else {
                    jQuery('.AddressCountry').removeClass('error');
                }
            if(!phone) {
              e.preventDefault();
                    jQuery('.AddressPhone').addClass('error');
                    jQuery('<span class="error-msg">Please enter phone number</span>').insertAfter('.AddressPhone');
                    NameError = 1;
                } else {
                    jQuery('.AddressPhone').removeClass('error');
                }
            if(!zipcode) {
              e.preventDefault();
                    jQuery('.AddressZip').addClass('error');
                    jQuery('<span class="error-msg">Please enter zipcode</span>').insertAfter('.AddressZip');
                    NameError = 1;
                } else {
                    jQuery('.AddressZip').removeClass('error');
                }
            if(!city) {
              e.preventDefault();
                    jQuery('.AddressCity').addClass('error');
                    jQuery('<span class="error-msg">Please enter city</span>').insertAfter('.AddressCity');
                    NameError = 1;
                } else {
                    jQuery('.AddressCity').removeClass('error');
                }
            if(!Name) {
              e.preventDefault();
                    jQuery('.AddressFirstName').addClass('error');
                    jQuery('<span class="error-msg">Please enter first name</span>').insertAfter('.AddressFirstName');
                    NameError = 1;
                } else {
                    jQuery('.AddressFirstName').removeClass('error');
                }
            if(!lname) {
              e.preventDefault();
                    jQuery('.AddressLastName').addClass('error');
                    jQuery('<span class="error-msg">Please enter last name</span>').insertAfter('.AddressLastName');
                    NameError = 1;
                } else {
                    jQuery('.AddressLastName').removeClass('error');
                }
            if(!address1) {
              e.preventDefault();
                    jQuery('.AddressAddress1').addClass('error');
                    jQuery('<span class="error-msg">Please enter address</span>').insertAfter('.AddressAddress1');
                    NameError = 1;
                } else {
                    jQuery('.AddressAddress1').removeClass('error');
                }

    
  });
        jQuery('.AddressProvince').parent().parent().addClass('has-focus');
        jQuery('.AddressCountry').parent().parent().addClass('has-focus');
        jQuery('#shopify-section-template--19201843560586__1759212286ed26a2c2').insertAfter('.product__description');
        setTimeout(function(){
        jQuery('.related-product-section').insertAfter('#shopify-section-template--19201843560586__1759212286ed26a2c2');
        },200);
     
    var currentPath = window.location.pathname; // e.g. "/pages/about"
        $(".footer__menu a").each(function(){
           if ($(this).attr("href") === currentPath) {
             $(this).addClass("active");
           }
        });
  
      if (window.location.hash === '#recover') {
            jQuery('body').addClass('forgot_password');
            jQuery('#recover').html('Forgotten Password');
            jQuery('.recover-text').show();
            jQuery('.recover-text').insertAfter('.login-page-title');
            // $('.breadcrumbs__list li:nth-child(2) a').text('Forgot Your Password?');
            jQuery('.breadcrumb').find('.sign-in-title').text('Password Forgotten');
     }
    jQuery('#recover-pass-form').on('click',function(){
    
        jQuery('#recover').html('Forgotten Password');
        jQuery('.recover-text').show();
        jQuery('.recover-text').insertAfter('.login-page-title');
        // jQuery('.breadcrumbs__list li:nth-child(2) a').text('Forgot Your Password?');
        jQuery('.breadcrumb ').find('.sign-in-title').text('Password Forgotten');
     
     });
     
    jQuery('.forgot-cancel').on('click',function(){
        jQuery('.breadcrumb ').find('.sign-in-title').text('Sign In');
    });

    jQuery('.reset-pass').on('click', function(e){
    var password = jQuery('#password').val();
    var Confirmation = jQuery('#password_confirmation').val();
    var reg_pwd = 0;

    // Remove any previous errors
    jQuery('#password').removeClass('error');
    jQuery('#password_confirmation').removeClass('error');
    jQuery('.error-msg').remove();

    if (password === "") {
        e.preventDefault();
        jQuery('#password').addClass('error');
        jQuery("<p class='error-msg'>Please enter a password</p>").insertAfter("#password");
        reg_pwd = 1;
    } else if (password.length < 6) {
        e.preventDefault();
        jQuery('#password').addClass('error');
        jQuery("<p class='error-msg'>Password must be at least 6 characters long</p>").insertAfter("#password");
        reg_pwd = 1;
    } else if (!validatePassword(password)) {
        e.preventDefault();
        jQuery('#password').addClass('error');
        jQuery("<p class='error-msg'>Password must contain at least one digit and one special character</p>").insertAfter("#ResetPassword");
        reg_pwd = 1;
    }

    if (Confirmation === "") {
        e.preventDefault();
        jQuery('#password_confirmation').addClass('error');
        jQuery("<p class='error-msg'>Please enter a confirmation password</p>").insertAfter("#password_confirmation");
        reg_pwd = 1;
    } else if (Confirmation.length < 6) {
        e.preventDefault();
        jQuery('#password_confirmation').addClass('error');
        jQuery("<p class='error-msg'>Confirmation password must be at least 6 characters long</p>").insertAfter("#password_confirmation");
        reg_pwd = 1;
    } else if (!validatePassword(Confirmation)) {
        e.preventDefault();
        jQuery('#password_confirmation').addClass('error');
        jQuery("<p class='error-msg'>Confirmation password must contain at least one digit and one special character</p>").insertAfter("#password_confirmation");
        reg_pwd = 1;
    } else if (password !== Confirmation) {
      e.preventDefault();
        jQuery('#password_confirmation').addClass('error');
        jQuery("<p class='error-msg'>Passwords do not match</p>").insertAfter("#password_confirmation");
        isValid = false;
    }

  });
   jQuery('#AddressPhoneNew').on('keypress', function(e) {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }  }); 
   
   jQuery('.AddressPhone').on('keypress', function(e) {
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }  }); 
    
 jQuery('.all-collections > li > a').on('click', function(e) {
    var $this = $(this);
    var $submenu = $this.next('.submenu');

    // If this menu has a submenu
    if ($submenu.length) {
      // If submenu is hidden → open it and prevent redirect
      if (!$submenu.is(':visible')) {
       // e.preventDefault();
        $('.submenu').slideUp(); // close all others
        $submenu.slideDown();   // open current one
      }
      // If submenu is visible → allow normal redirect on second click
    }
  });
   var currentPath = window.location.pathname;

  $('.submenu a').each(function() {
    var $link = $(this);
    if ($link.attr('href') === currentPath) {
     // $link.addClass('active');                  // highlight active submenu
      $link.closest('.submenu').hide();          // open that submenu
     // $link.closest('li').parent().parent().addClass('active'); // mark parent li as active
    }
  });

  // --- AUTO OPEN MAIN MENU IF CURRENT PAGE IS A MAIN MENU ITEM ---
  $('.all-collections > li > div > a').each(function() {
  var $link = $(this);
  var $submenu = $link.closest('.link-icon-wrap').next('.submenu');

  if ($link.attr('href') === currentPath && $submenu.length) {
    //$submenu.show();
   // $link.addClass('active');
   // $link.closest('li').addClass('active');
    //$link.closest('li').addClass('current-page-menu');
    $link.closest('li .submenu').hide();
    
  }
});
$('.all-collections li.active .link-icon-wrap').addClass('open');
  if (window.location.href.indexOf("swym-wishlist") > -1) {
    $('.swym-wishlist').addClass('active');
  }
}); 
$(window).on('load', function() {
  function initRelatedProducts() {
    var $carousel = $('.related-product-section .product-grid');

   // if ($carousel.length && !$carousel.hasClass('owl-loaded')) {
      $carousel.owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        responsive: {
          0: { items: 2, dots: true },
          600: { items: 3, dots: true },
          1000: { items: 6 }
        }
      });
    }
  //}

  // Initialize when page fully loaded
  initRelatedProducts();

  // Reinitialize when Shopify dynamically loads sections
  $(document).on('shopify:section:load', initRelatedProducts);

    const loadMoreBtn = document.querySelector('#load-more');
  const noMoreMsg = document.querySelector('#no-more-products');
  const productGrid = document.querySelector('#product-grid');

  if (!loadMoreBtn || !productGrid) return;

  let currentPage = 1;
  const productsPerPage = parseInt('{{ collection.products_per_page }}');
  const totalProducts = parseInt('{{ collection.products_count }}');
  const totalPages = Math.ceil(totalProducts / productsPerPage);

  loadMoreBtn.addEventListener('click', function () {
    currentPage++;
    loadMoreBtn.textContent = 'Loading...';

    fetch(`${window.location.pathname}?page=${currentPage}&section_id=main-collection-product-grid`)
      .then(res => res.text())
      .then(data => {
        const html = new DOMParser().parseFromString(data, 'text/html');
        const newProducts = html.querySelectorAll('#product-grid > *');

        newProducts.forEach(item => productGrid.appendChild(item));

        loadMoreBtn.textContent = 'Show more stuff!';

        if (currentPage >= totalPages) {
          loadMoreBtn.style.display = 'none';
          noMoreMsg.style.display = 'block';
        }
      })
      .catch(err => {
        console.error('Error loading more products:', err);
        loadMoreBtn.textContent = 'Show more stuff!';
      });
  });
});

